<template>
  <DatePicker
    :popover="popover"
    :value="value"
    @input="$emit('input', $event)"
    :timezone="timezone"
    mode="dateTime"
    :clearable="true"
  >
    <template v-slot="{ inputValue, inputEvents }">
      <v-text-field
        :rules="[rules.required]"
        :value="inputValue"
        :label="label"
        prepend-icon="event"
        readonly
        color="primary"
        v-on="inputEvents"
        :prefix="momentTz.tz(timezone).format('z')"
        :hint="hint"
        persistent-hint
        @keydown.native="handleKey"
      >
        {{ inputValue }}
        <template v-if="is_tooltip && tooltip_content" v-slot:append>
          <v-tooltip top color="white">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
            </template>
            <div
              class="grey--text text--darken-3 body-1"
              v-html="tooltip_content"
            >
              {{ tooltip_content }}
            </div>
          </v-tooltip>
        </template>
      </v-text-field>
    </template>
  </DatePicker>
</template>
<script>
import {DatePicker, Calendar} from "v-calendar";
import rules from "@/validation";
import { mapGetters } from "vuex";
export default {
  props: [
    "value",
    "label",
    "datetime",
    "is_tooltip",
    "tooltip_content",
    "hint",
  ],
  name: "dateTimePicker",
  data() {
    return {
      rules,
      popover: {
        visibility: "focus",
        positionFixed: true,
      },
    };
  },
  computed: {
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone",
    }),
  },
  components: {
    Calendar,
    DatePicker,
  },
  methods: {
    handleKey(event) {
      if (event.key === 'Backspace' || event.key === 'Delete') {
        this.$emit('input', null); // Clear the bound value
      }
    }
  },
};
</script>
